import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import userReducer from '../features/user/userSlice';
import dreamReducer from '../features/dream/dreamSlice';
import dreamLogReducer from '../features/dreamLog/dreamLogSlice';
import interpreterReducer from '../features/interpreter/interpreterSlice';
import paymentsReducer from '../features/payments/paymentsSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    user: userReducer,
    dream: dreamReducer,
    dreamLog: dreamLogReducer,
    interpreter: interpreterReducer,
    payments: paymentsReducer,
  },
});
